import { BrowserRouter } from 'react-router-dom';
import { createRoot } from 'react-dom/client';
import App from './App';
import { loadConfig } from './providers/ConfigProvider';
import { AnalyticsProvider } from './hooks/analytics';
import { AppConfig } from '../../k1-portal-api/src/config/appConfig';
import { ThemeProvider } from '@mui/material';
import { getMuiTheme, ForgeTheme } from '@forgeglobal/forge-component-library';

import './assets/css/fonts.css';

(async () => {
  const config = await loadConfig();

  const rootElement = document.getElementById('root');
  const root = createRoot(rootElement!);

  const createAnalyticsConfig = (config: AppConfig) => {
    return {
      googleAnalyticsTrackingId: config.GOOGLE_ANALYTICS_TRACKING_ID,
      heapAppId: config.HEAP_APP_ID,
      appInsightsInstrumentationKey: config.APPINSIGHTS_INSTRUMENTATIONKEY,
      logRocketAppId: config.LOGROCKET_APP_ID,
    };
  };

  const analyticsConfig = createAnalyticsConfig(config);

  root.render(
    <BrowserRouter basename={config.REACT_APP_BASE_PATH}>
      <AnalyticsProvider config={analyticsConfig}>
        <ThemeProvider theme={getMuiTheme(ForgeTheme.ForgeLight)}>
          <App />
        </ThemeProvider>
      </AnalyticsProvider>
    </BrowserRouter>,
  );
})();
